import { render } from "./EditOfficialMessage.vue?vue&type=template&id=0e149072&scoped=true"
import script from "./EditOfficialMessage.vue?vue&type=script&lang=js"
export * from "./EditOfficialMessage.vue?vue&type=script&lang=js"

import "./EditOfficialMessage.vue?vue&type=style&index=0&id=0e149072&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e149072"]])

export default __exports__